// copy from $ui5-palette-project
const colorsString = '#28AFF0, #3F74FC, #00C9B2, #43C464,\n' +
    '        #F5B800, #FF841F, #FF6157, #F23F6A,\n' +
    '        #DE35C1, #7F5AF2, #B57A5C, #515B69'

// get all project colors and fill colors array with hex values
const ProjectColorsPalette: string[] = []
_.map(colorsString.split(','), color=>{
    ProjectColorsPalette.push(color.trim())
})

export default ProjectColorsPalette